export default "__VITE_ASSET__A1Q33tDY__"